(() => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  const countdown = document.querySelector('[data-countdown]');
  if (countdown) {
    const hoursEl = countdown.querySelector('[data-countdown-hours]');
    const minsEl = countdown.querySelector('[data-countdown-mins]');
    const secsEl = countdown.querySelector('[data-countdown-secs]');

    const pad = (n) => String(n).padStart(2, '0');
    const endOfDay = () => {
      const now = new Date();
      const end = new Date(now);
      end.setHours(23, 59, 59, 999);
      return end;
    };

    const tick = () => {
      const diff = Math.max(0, endOfDay() - Date.now());
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      if (hoursEl) hoursEl.textContent = pad(h);
      if (minsEl) minsEl.textContent = pad(m);
      if (secsEl) secsEl.textContent = pad(s);
    };

    tick();
    setInterval(tick, 1000);
  }

  document.querySelectorAll('[data-faq-tab]').forEach((tab) => {
    tab.addEventListener('click', () => {
      const id = tab.getAttribute('data-faq-tab');
      document.querySelectorAll('[data-faq-tab]').forEach((t) => {
        const active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      document.querySelectorAll('[data-faq-panel]').forEach((panel) => {
        const active = panel.getAttribute('data-faq-panel') === id;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    });
  });

  const sticky = document.querySelector('[data-sticky-atc]');
  const form = document.getElementById('ProductForm');
  const addBtn = document.querySelector('[data-add-to-cart]');
  const triggers = document.querySelectorAll('[data-sticky-atc-trigger]');

  if (sticky && addBtn) {
    sticky.hidden = false;
    const syncSticky = () => {
      const rect = addBtn.getBoundingClientRect();
      sticky.classList.toggle('is-visible', rect.bottom < 0);
    };
    window.addEventListener('scroll', syncSticky, { passive: true });
    syncSticky();

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (form && typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else if (form) {
          form.submit();
        }
      });
    });
  }

  const gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const fullSrc = thumb.getAttribute('data-full-src');
        if (!main || !fullSrc) return;
        main.src = fullSrc;
        thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
      });
    });
  }
})();
